import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import NotFound from '../pages/NotFound';
import AddictionServicesPage from '../pages/addiction-services/page';
import LocationPage from '../pages/location/page';
import PharmacyServicesPage from '../pages/pharmacy-services/page';
import PrivacyPage from '../pages/privacy/page';
import WhatIsAddictionPage from '../pages/what-is-addiction/page';
import MethadoneTreatmentPage from '../pages/methadone-treatment/page';
import SuboxoneTreatmentPage from '../pages/suboxone-treatment/page';
import NaloxoneKitsPage from '../pages/naloxone-kits/page';
import DrugUsePage from '../pages/drug-use/page';
import AreYouAddictedPage from '../pages/are-you-addicted/page';
import AdminLoginPage from '../pages/admin/login/page';
import AdminDashboardPage from '../pages/admin/dashboard/page';
import AdminPharmacySettingsPage from '../pages/admin/pharmacy-settings/page';
import AdminBlogPage from '../pages/admin/blog/page';
import BlogListPage from '../pages/blog/page';
import BlogPostPage from '../pages/blog/BlogPostPage';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/addiction-services',
    element: <AddictionServicesPage />,
  },
  {
    path: '/location',
    element: <LocationPage />,
  },
  {
    path: '/pharmacy-services',
    element: <PharmacyServicesPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/what-is-addiction',
    element: <WhatIsAddictionPage />,
  },
  {
    path: '/methadone-treatment',
    element: <MethadoneTreatmentPage />,
  },
  {
    path: '/suboxone-treatment',
    element: <SuboxoneTreatmentPage />,
  },
  {
    path: '/naloxone-kits',
    element: <NaloxoneKitsPage />,
  },
  {
    path: '/drug-use',
    element: <DrugUsePage />,
  },
  {
    path: '/are-you-addicted',
    element: <AreYouAddictedPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/admin/pharmacy-settings',
    element: <AdminPharmacySettingsPage />,
  },
  {
    path: '/admin/blog',
    element: <AdminBlogPage />,
  },
  {
    path: '/blog',
    element: <BlogListPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;